import constants from "@/constants";

export const DetailGraphLoadingIndicator = {

  text: '',
  color: constants.COLORS.OSF_BLUE,
  textColor: '#000',
  maskColor: 'rgba(255, 255, 255, 0.8)',
  zlevel: 0,

  // Font size. Available since `v4.8.0`.
  fontSize: 30,

  showSpinner: true,

  spinnerRadius: 25,

  lineWidth: 5,

};